import { createMuiTheme } from '@material-ui/core/styles';
import KenColors from './KenColors';
import { typography } from './base-theme';

export const overridings = {
  name: 'Light Theme',
  KenColors,
  palette: {
    KenColors,
    primary: {
      light: KenColors.neutral700,
      main: KenColors.primary,
      dark: KenColors.neutral900,
      contrastText: '#fff',
    },
    secondary: {
      light: KenColors.shadowColor,
      main: KenColors.primary,
      dark: KenColors.secondaryPrime,
      contrastText: '#fff',
    },
  },
  typography: typography(KenColors),
};

export const createLightTheme = (color) => {
  const overrideTheme = {
    name: 'Light Theme',
    KenColors: (KenColors.primary = color.primary),
    palette: {
      KenColors,
      primary: {
        light: KenColors.neutral700,
        main: color.primary,
        dark: KenColors.neutral900,
        contrastText: '#fff',
      },
      type: 'light',
      secondary: {
        light: KenColors.shadowColor,
        main: color.secondary,
        dark: KenColors.secondaryPrime,
        contrastText: '#fff',
      },
    },
    typography,
  };
  return createMuiTheme(overrideTheme);
};

export default createMuiTheme(overridings);
